import React from 'react';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import mobileApps from '../../../../images/mobileApps.png';
import LearnMoreCommon from '../LearnMoreCommon';

const MobileAppDevelopmentPage = props => {
    const { t } = props;
    return (
        <LearnMoreCommon
            cardMediaImage={mobileApps}
            cardMediaTitle={t(
                'landingPage.serviceSection.services.mobileAppDevelopment.header'
            )}
            headerTitle={t(
                'landingPage.serviceSection.services.mobileAppDevelopment.header'
            )}
            firstBlockText={t(
                'landingPage.serviceSection.services.mobileAppDevelopment.learnMore.firstBlock'
            )}
            contactUsDescription={t(
                'landingPage.serviceSection.services.mobileAppDevelopment.learnMore.contactUs'
            )}
            googleEventCategory="Services - MobileAppDevelopmentPage"
        />
    );
};

export default compose(withTranslation())(MobileAppDevelopmentPage);
